import "./wdyr";
import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

// Local imports
import "./utils/httpClient";
import App from "./App";
import rootReducer from "./reducers";
import ErrorBoundary from "./pages/other/ErrorBoundary";

// Assets
import "./styles/main.css";
import "./pages/molier_diagram/plotstyles.css";
// import "./pages/tecnicalCard/techicalCard.css";
import "./pages/tecnicalCard/dugme.css";
// Language locales
import "./locales/i18nextConfig";
import "../src/locales/i18nextConfig";

const reduxStore = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

ReactDOM.render(
  <Provider store={reduxStore}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById("root")
);
